import { useEffect } from "react";
import "../../styles/Contents.css";

export default function DDPs() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">

      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Daily Practice Problems (DPPs)</h1>
        <p>
          Structured daily practice sets for Classes 8, 9 & 10,
          aligned with both CBSE and State syllabus to enhance problem-solving skills.
        </p>
      </section>

      {/* WHAT ARE DDPS */}
      <section className="about-section reveal-left">
        <div className="about-text">
          <h2>What are DDPs?</h2>
          <p>
            DDPs are carefully curated topic-wise problem sets that students
            can solve daily to strengthen concepts, reinforce learning,
            and improve accuracy.
          </p>
          <p>
            Each set is designed to gradually increase difficulty and
            challenge students in a structured manner, helping them excel
            in school exams and competitive assessments.
          </p>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="mission-section reveal-right">
        <h2>Benefits of Daily Practice</h2>

        <div className="mission-grid reveal">
          <div className="mission-card">
            <h3>🧠 Concept Reinforcement</h3>
            <p>
              Solve problems regularly to strengthen understanding
              and memory retention.
            </p>
          </div>

          <div className="mission-card">
            <h3>⏱️ Time Management</h3>
            <p>
              Practicing daily helps students complete questions
              efficiently within limited exam time.
            </p>
          </div>

          <div className="mission-card">
            <h3>📊 Track Progress</h3>
            <p>
              Monitor improvement over time and identify weak areas
              for focused revision.
            </p>
          </div>

          <div className="mission-card">
            <h3>📚 All Subjects Covered</h3>
            <p>
              Mathematics, Science, Social Science, and Languages
              for Classes 8, 9 & 10 are included.
            </p>
          </div>

          <div className="mission-card">
            <h3>✔ CBSE & State Boards</h3>
            <p>
              Designed for students following both CBSE and State board
              syllabi.
            </p>
          </div>

          <div className="mission-card">
            <h3>🏆 Exam Readiness</h3>
            <p>
              Regular practice ensures confidence and better performance
              during exams.
            </p>
          </div>
        </div>
      </section>

      {/* HOW TO USE */}
      <section className="mission-section reveal-left">
        <h2>How to Use DDPs Effectively</h2>
        <ul style={{ fontSize: "15px", color: "#475569", marginTop: "12px" }}>
          <li>✔ Solve problems daily as per your syllabus.</li>
          <li>✔ Start with easier questions, then gradually attempt advanced ones.</li>
          <li>✔ Review mistakes and redo problems to reinforce learning.</li>
          <li>✔ Combine with Notes and Previous Papers for complete exam preparation.</li>
          <li>✔ Track your performance weekly and adjust focus areas.</li>
        </ul>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          Daily Practice Problems are designed to help students build
          consistency, improve accuracy, and master concepts in all subjects.
          Regular practice is the key to academic excellence.
        </p>
      </section>

    </div>
  );
}
